export const SERVER_ADDRESS = "https://mywork-e26p.onrender.com/api/v1";
// export const SERVER_ADDRESS = "http://127.0.0.1:3030/api/v1";
export const CLIENT_ADDRESS = "https://myworkrecord.netlify.app/";

export const REGISTER_CODE = "ONLYTEACHER";
